<template lang="pug">
.related-article-card
    .grip
        i.fas.el-icon-fa-grip-vertical
    .thumbnail
        img(
            v-if="thumbnailUrl"
            :src="thumbnailUrl"
            :alt="article.sku"
        )
        .placeholder(v-else)
            i.fas.el-icon-fa-image
    .info
        .sku {{ article.sku }}
        .name {{ articleName }}
    el-button.delete-button(
        circle
        type="info"
        size="mini"
        icon="el-icon-fa-trash-alt far"
        @click.stop.prevent="$emit('remove', article)"
    )
</template>

<script>
import _ from 'lodash';

export default {
    name: 'RelatedArticleCard',
    props: {
        article: {
            type: Object,
            required: true
        }
    },
    computed: {
        thumbnailUrl() {
            // Try article media first
            const media = _.get(this.article, 'media') || [];
            if (media.length) {
                const sortedMedia = _.sortBy(media.filter(m => m.type === 'image'), 'position');
                const imageMedia = sortedMedia.find(m => {
                    const disabled = _.get(m, 'settings.show.disabled', false);
                    return !disabled;
                }) || sortedMedia[0];
                if (imageMedia) {
                    const url = _.get(imageMedia, 'image.source.url');
                    if (url) return url;
                }
            }
            // Fallback to product media
            const productMedia = _.get(this.article, 'product.media') || [];
            if (productMedia.length) {
                const sortedProductMedia = _.sortBy(productMedia.filter(m => m.type === 'image'), 'position');
                const productImageMedia = sortedProductMedia.find(m => {
                    const disabled = _.get(m, 'settings.show.disabled', false);
                    return !disabled;
                }) || sortedProductMedia[0];
                if (productImageMedia) {
                    const url = _.get(productImageMedia, 'image.source.url');
                    if (url) return url;
                }
            }
            return null;
        },
        articleName() {
            return this.article.name || _.get(this.article, 'product.name') || '';
        }
    }
};
</script>

<style lang="sass" scoped>
.related-article-card
    position: relative
    display: flex
    align-items: center
    padding: 8px 10px
    background: #fff
    border: 1px solid #e4e7ed
    border-radius: 4px
    width: 240px
    min-width: 240px

    &:hover
        .delete-button
            opacity: 1

    .grip
        cursor: grab
        padding: 0 8px 0 0
        color: #c0c4cc
        font-size: 12px

        &:active
            cursor: grabbing

    .thumbnail
        width: 40px
        height: 40px
        min-width: 40px
        margin-right: 10px
        border-radius: 4px
        overflow: hidden
        background: #f5f7fa
        display: flex
        align-items: center
        justify-content: center

        img
            width: 100%
            height: 100%
            object-fit: cover

        .placeholder
            color: #c0c4cc
            font-size: 16px

    .info
        flex: 1
        min-width: 0
        overflow: hidden
        padding-right: 24px
        line-height: 1.3

        .sku
            font-size: 12px
            font-weight: 500
            color: #303133
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis

        .name
            font-size: 11px
            color: #909399
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis

    .delete-button
        position: absolute
        top: 4px
        right: 4px
        opacity: 0
        transition: opacity 0.2s
</style>
